import axios, { type AxiosInstance } from 'axios'
import { PentaError } from '@/utils/PentaError'

let axiosInstance: AxiosInstance

if (window.player?.config?.apikey) { // Si comparto codigo con el player que usa servicios cambia el axiosInstance
  axiosInstance = axios.create({
    baseURL: window.path?.remote?.('') || window.location.origin,
    headers: {
      apikey: window.player?.config?.apikey || localStorage.getItem('ak')
    }
  })
} else {
  axiosInstance = axios.create({
    baseURL: '',
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// Normaliza cualquier rechazo de axios a un PentaError, preservando el shape rico que devuelve src/errorHandler.js (_id, randId, name, frontendInfo).
// IMPORTANTE: este interceptor debe quedar registrado antes que cualquier otro (ej. LoadingVeil.vue) que también intercepte errores de este
// axiosInstance, porque axios ejecuta los interceptores de respuesta en orden de registro (FIFO) y los demás dependen de recibir ya un PentaError.
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const pentaError = error?.response?.data
      ? new PentaError(error.response.data)
      : toGenericPentaError(error)
    // El PentaError no conserva error.config: se propaga _ignoreVeil para que LoadingVeil.vue no apague el velo por una request de fondo
    ;(pentaError as any)._ignoreVeil = (error?.config as any)?._ignoreVeil
    return Promise.reject(pentaError)
  }
)

// Error sin respuesta del backend (red caída, timeout, abort, CORS): el stack solo apunta a internals de axios, por eso se
// guarda en extraInfo qué request falló y por qué. Va solo al errorLog, al usuario se le sigue mostrando el toast genérico.
// No se loguean params ni body: pueden traer datos sensibles.
function toGenericPentaError(error: any): PentaError {
  return new PentaError({ message: 'generic', source: 'axios', stack: error?.stack }).extraInfo('request', {
    method: error?.config?.method,
    url: error?.config?.url,
    code: error?.code,
    message: error?.message
  })
}

export default axiosInstance